import { css } from 'styled-system/css';

export const logoBannerStyles = {
	banner: css({
		base: {
			w: '100%',
			h: '64px',
			backgroundImage: 'url(/images/sign-up/logo-banner.png)',
			backgroundRepeat: 'no-repeat',
			backgroundPositionX: 'center',
			bgColor: '#020F20',
			_site42018: {
				bgColor: '#070C26',
				bgPositionY: '-70px',
			},
			_site42021: {
				bgColor: '#000000',
				bgPositionY: '-140px',
			}, // Aoncash
			_site42024: {
				bgColor: '#090101',
				bgPositionY: '-210px',
			}, // ITCBet
			_site42156: {
				bgColor: '#37D1DB',
				bgPositionY: '-280px',
			}, // Bolanation
			_site42063: {
				bgColor: '#000000',
				bgPositionY: '-350px',
			}, // 9bet
			_site42094: {
				bgColor: '#0A1802',
				bgPositionY: '-420px',
			}, // M8Bola
			_site42102: {
				bgColor: '#1A1A1A',
				bgPositionY: '-490px',
			}, // Q8Bola
		}
	}),
	logo: css({
		base: {
			position: 'relative',
			w: '215px',
			h: '64px',
			m: '0 auto',
			display: 'flex',
			alignContent: 'center'
		}
	})
}

